import { lighten } from "polished";
import * as React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import Grid from "src/library/components/Hedron";
import { HtmlBody } from "src/library/components/Notes";
import { Icons } from "src/library/components/Icon/types";
import { Icon } from "src/library/components/Icon";

interface ErrorNoticeProps {
  message?: string | null;
  type: "error" | "warn" | "success" | "info";
  children?: React.ReactNode;
  icon?: Icons;
}

export const ErrorNotice: React.ReactFCWithChildren<ErrorNoticeProps> = ({
  message, type, children, icon
}) => {
  if (!message && !children) {
    return null;
  }

  return (
    <ErrorNoticeWrapper
      type={type}
      className="error-notice"
    >
      {icon && (
        <Icon
          icon={icon}
          size={15}
        />
      )}

      {message && (
        <Text weight="bold">
          <HtmlBody body={message} />
        </Text>
      )}

      {children && children}
    </ErrorNoticeWrapper>
  );
};

const ErrorNoticeWrapper = styled(Grid.Box)<Pick<ErrorNoticeProps, "type">>`
  ${({ theme, type }) => css`
    background: ${type === "info" ? theme.colors.white : lighten(0.1, theme.colors[ type ])};
    border: 1px solid ${type === "info" ? theme.colors.primaryDark : theme.colors[ type ]};
    padding: ${theme.spacing.padding.sm};
    margin-bottom: ${theme.spacing.margins.md};
    display: flex; 
    flex-direction: row;
    align-items: center;
    
    svg {
      margin-right: ${theme.spacing.margins.sm};
    }
  `}
`;
